import {Injectable, Injector} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot} from '@angular/router';
import {Observable} from "rxjs";
import {RouteData} from "../services/route-data/route-data";
import {SubscriptionUpgradeAvailableGuard} from "../../workspace/upgrade-plan/subscription-upgrade-available.guard";

@Injectable()
export class SequenceGuard implements CanActivate {

  private guards;

  constructor(
    private _injector: Injector
  ) {
  }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    const routeData: RouteData = new RouteData(next.data);

    if (routeData && routeData.guards && routeData.guards.length) {
      this.guards = routeData.guards.map(guard => this._injector.get(guard));
      return this.executeGuards(next, state);
    }

    return true;
  }

  private executeGuards(next: ActivatedRouteSnapshot, state: RouterStateSnapshot, guardIndex: number = 0): Promise<boolean> {
    return this.guards[guardIndex].canActivate(next, state)
      .then(passed => {
          if ((guardIndex + 1 < this.guards.length) && passed) {
            return this.executeGuards(next, state, guardIndex + 1);
          } else {
            return passed ? Promise.resolve(true) : Promise.reject();
          }
        },
        () => Promise.reject()
      )
      .catch(() => Promise.reject());
  }

}
